module.exports = __webpack_public_path__ + "img/bg_avatar_female_37.941ca7eb.png";